import Alpine from 'alpinejs'
import { fragment, escapeHTML, uuid } from '@js/util/helpers.js'
import { doesMatch, watch } from '@js/util/breakpoints.js'

// Define (mobile) menu open/close state
Alpine.store('menu', false)

let menuBreakpoint = 'lg'
Alpine.store('isMobile', !doesMatch(menuBreakpoint))
watch(menuBreakpoint, matches => {
  Alpine.store('isMobile', !matches)
})

// Define transition options for menu animations
Alpine.store('menuTransitions', {
  // The whole mobile menu when toggled
  mobileMenu: {
    css: {
      opacity: 0,
      transform: 'translateY(0px)',
    },
    duration: 200,
    // Visuals controlled by the global 'menu' state
    bind: 'menu',
  },
  // A submenu expanding/collapsing on mobile
  mobileSubmenu: {
    css: {
      opacity: 0,
      transform: 'translateX(40px)',
    },
    duration: 300,
    // Hide overflow during animation to properly visualize height transition
    onBeforeAnimate(element) {
      element.style.overflow = 'hidden'
    },
    onComplete(element) {
      element.style.removeProperty('overflow')
    },
  },
})

// We'll attach the Alpine menu logic via JS because it would be *very* tedious
// to do so via the various hooks WordPress provides for menu HTML generation.
// A non-JS fallback is ensured through pure CSS.
document.querySelectorAll('nav.main').forEach(menuNavContainer => {
  let isMobile = menuNavContainer.matches('.main.mobile *')

  // Iterate all top-level list items that have submenus
  menuNavContainer.querySelectorAll('.menu > .menu-item-has-children').forEach(menuItem => {
    let submenuList = menuItem.querySelector('.sub-menu')
    let menuItemLink = menuItem.querySelector('a')

    submenuList.setAttribute('x-bind', 'target')
    submenuList.setAttribute('x-ref', 'target')

    // Make submenu focusable as a whole and hide it
    submenuList.setAttribute('tabindex', '-1')

    if (isMobile) {
      submenuList.style.display = 'none'

      let menuItemIdClass = [...menuItem.classList].find(className =>
        /^menu-item-[0-9]+$/.test(className),
      )
      let submenuId = menuItemIdClass
        ? `submenu-${menuItemIdClass.replace('menu-item-', '')}`
        : `submenu-${uuid()}`

      submenuList.setAttribute('id', submenuId)
      submenuList.setAttribute('x-trap', 'isMenuVisible() && isVisible()')
      submenuList.insertBefore(
        fragment`
          <li
            class="back-item"
            :class="{
              'offset-menu': isAnimatingMenu($refs.toggleContainer),
              'offset-submenu': isAnimating($refs.target)
            }"
            x-ref="backItem"
          >
            <button
              class="back-button"
              @click="hide()"
            >
              <svg class="back-icon" aria-hidden="true" focusable="false" width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg"><path d="M8.74 18.074a.84.84 0 0 0 1.188 0l.562-.563a.84.84 0 0 0 0-1.187L3.5 9.334l6.99-6.99a.84.84 0 0 0 0-1.188L9.928.594a.84.84 0 0 0-1.188 0L.594 8.74a.84.84 0 0 0-.075 1.102l.075.086 8.146 8.146Z" fill="#000" fill-rule="nonzero"/></svg>
              <span class="back-label">Zurück<span class="sr-only"> zum Hauptmenü</span></span>
            </button>
          </li>
          <li class="submenu-title">${menuItemLink.textContent}</li>
        `,
        submenuList.firstChild,
      )

      // Disable link clickability if it points to empty anchor
      // Make it show the submenu instead
      if (menuItemLink.getAttribute('href') === '#') {
        menuItemLink.setAttribute('x-on:click.prevent', 'toggle()')
      } else if (isMobile && menuItemLink.getAttribute('href').startsWith('#')) {
        menuItemLink.setAttribute('x-on:click', '$store.menu = false')
      }

      menuItem.setAttribute('x-data', `transition($store.menuTransitions.mobileSubmenu)`)
      // if (
      //   menuItem.classList.contains('current_page_item') ||
      //   menuItem.querySelector('.current_page_item')
      // ) {
      //   menuItem.setAttribute('x-init', 'setTimeout(() => { show() }, 0)')
      // }

      // Insert dropdown icon after link
      menuItemLink.parentNode.insertBefore(
        fragment`
          <button type="button" class="dropdown" @click="toggle()" :aria-expanded="isVisible()" :aria-controls="${JSON.stringify(
            submenuId,
          )}">
            <svg aria-hidden="true" focusable="false" width="12" height="19.2" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg"><path d="M2.273 15.061a.7.7 0 0 1-.99 0l-.468-.468a.7.7 0 0 1 0-.99L6.64 7.778.815 1.953a.7.7 0 0 1 0-.99l.468-.468a.7.7 0 0 1 .99 0l6.788 6.788a.7.7 0 0 1 .063.918l-.063.072-6.788 6.788Z" fill="#000" fill-rule="nonzero"/></svg>
            <span class="sr-only">Unterpunkte von "${escapeHTML(
              menuItemLink.textContent,
            )}" anzeigen</span>
          </button>
        `,
        menuItemLink.nextSibling,
      )
    }
  })
})

document.querySelectorAll('nav.secondary').forEach(menuNavContainer => {
  let isMobile = menuNavContainer.matches('.main.mobile *')

  menuNavContainer.querySelectorAll('a').forEach(menuItemLink => {
    if (isMobile && menuItemLink.getAttribute('href').startsWith('#')) {
      menuItemLink.setAttribute('x-on:click', '$store.menu = false')
    }
  })
})
